import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);


  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const closeMenu = () => {
    setMenuOpen(false);
  };



  useEffect(() => {
    function handleScroll() {
      if (window.pageYOffset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className={`Navbar ${scrolled ? "scrolled" : ""}`}>
        <h3 className="heading">
          <span className="span">S.</span>WAJAHAT ALI
        </h3>

        <div className="navanchor">
          <ul>
            <li>
              <Link className="a" to="/">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  stroke="#ffffff"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    {" "}
                    <path
                      d="M19 9L19 17C19 18.8856 19 19.8284 18.4142 20.4142C17.8284 21 16.8856 21 15 21L14 21L10 21L9 21C7.11438 21 6.17157 21 5.58579 20.4142C5 19.8284 5 18.8856 5 17L5 9"
                      stroke="#fffafa"
                      stroke-width="2"
                      stroke-linejoin="round"
                    ></path>{" "}
                    <path
                      d="M3 11L7.5 7L10.6713 4.18109C11.429 3.50752 12.571 3.50752 13.3287 4.18109L16.5 7L21 11"
                      stroke="#fffafa"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>{" "}
                    <path
                      d="M10 21V17C10 15.8954 10.8954 15 12 15V15C13.1046 15 14 15.8954 14 17V21"
                      stroke="#fffafa"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>{" "}
                  </g>
                </svg>
                Home
              </Link>
            </li>

            <li>
              <Link className="a" to="/About">
                <svg
                  height="121px"
                  width="121px"
                  version="1.1"
                  id="_x32_"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="-46.08 -46.08 604.16 604.16"
                  fill="#ffffff"
                  stroke="#ffffff"
                  stroke-width="6.656000000000001"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke="#CCCCCC"
                    stroke-width="1.024"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    {" "}
                    <style type="text/css"> </style>{" "}
                    <g>
                      {" "}
                      <path
                        class="st0"
                        d="M464.496,431.904c-13.636-24.598-34.497-41.724-54.571-53.835c-20.086-12.104-39.685-19.308-51.156-23.611 c-8.74-3.246-17.968-7.456-24.307-11.92c-3.174-2.204-5.578-4.463-6.91-6.3c-1.363-1.883-1.635-3.04-1.646-3.958 c0-8.743,0-19.675,0-34.305c1.263-3.193,2.584-5.796,4.076-8.215c2.527-4.15,5.892-8.344,9.268-14.653 c2.802-5.26,5.302-11.882,7.235-20.548c1.7-0.827,3.395-1.784,5.048-2.94c5.068-3.499,9.356-8.598,12.862-15.266 c3.545-6.699,6.604-15.098,9.865-26.474l-0.027,0.076l0.027-0.084c1.677-5.902,2.481-11.086,2.484-15.802 c0.058-7.579-2.312-14.148-6.232-18.582c-1.366-1.569-2.844-2.756-4.329-3.782c0.494-5.834,1.385-13.574,2.231-22.5 c0.98-10.358,1.864-22.202,1.864-34.467c-0.038-19.408-2.105-39.902-10.316-57.587c-4.115-8.82-9.887-16.934-17.769-23.342 c-7.262-5.918-16.33-10.16-26.849-12.395c-7.139-5.474-14.052-10.266-22.669-13.597c-9.302-3.605-20.039-5.274-34.222-5.266 c-4.475,0-9.317,0.16-14.615,0.482C229.032,3.1,216.909,4.9,205.203,4.869c-8.165-0.008-16.223-0.789-25.559-3.446L174.642,0 l-3.985,3.338c-12.261,10.412-18.842,25.93-22.868,43.171c-3.978,17.318-5.267,36.786-5.279,56.087 c0.004,25.188,2.255,50.069,4.169,68.742c-1.459,0.949-2.909,2.044-4.284,3.506c-4.226,4.426-6.875,11.27-6.802,19.209 c0.004,4.708,0.808,9.891,2.484,15.786l0.008,0.031c4.356,15.158,8.295,25.088,13.624,32.621c2.656,3.744,5.742,6.806,9.095,9.126 c1.646,1.148,3.33,2.098,5.022,2.924c3.035,12.969,8.146,22.37,12.529,29.176c2.465,3.851,4.643,6.913,5.99,9.202 c1.29,2.144,1.673,3.369,1.75,3.928c0,15.228,0,26.451,0,35.431c0.004,0.713-0.276,1.968-1.792,3.982 c-2.197,2.978-6.99,6.775-12.735,9.991c-5.735,3.269-12.361,6.102-18.16,8.146c-15.614,5.528-45.239,16.315-71.468,37.315 c-13.114,10.511-25.425,23.665-34.478,40.094C38.405,448.22,32.72,467.91,32.74,490.794c0,3.973,0.169,8.054,0.517,12.226 l0.75,8.98h443.986l0.75-8.98c0.348-4.164,0.517-8.23,0.517-12.203C479.279,467.941,473.579,448.28,464.496,431.904z M459.592,492.401H52.408c-0.008-0.528-0.069-1.087-0.069-1.607c0.015-19.684,4.754-35.814,12.291-49.534 c11.289-20.533,29.242-35.692,47.474-46.686c18.217-10.994,36.453-17.692,47.818-21.696c8.954-3.169,19.354-7.756,28.212-13.903 c4.429-3.093,8.506-6.577,11.782-10.871c3.235-4.241,5.773-9.623,5.776-15.825c0-9.149,0-20.579,0-36.258v-0.505l-0.054-0.506 c-0.532-4.9-2.48-8.766-4.444-12.096c-3.013-5.023-6.4-9.394-9.497-15.059c-3.085-5.643-5.96-12.456-7.667-22.049l-0.992-5.604 l-5.359-1.914c-2.45-0.88-4.203-1.73-5.681-2.756c-2.174-1.546-4.187-3.613-6.744-8.368c-2.519-4.723-5.286-11.996-8.322-22.669 v-0.007c-1.305-4.548-1.742-7.993-1.742-10.435c0.077-4.196,1.01-5.183,1.516-5.819c0.543-0.612,1.512-1.079,2.587-1.317 l8.521-1.906l-0.915-8.682c-2.01-19.048-4.792-46.532-4.792-73.734c-0.008-18.382,1.297-36.626,4.777-51.685 c2.887-12.717,7.415-22.822,13.05-29.253c9.053,2.066,17.436,2.817,25.268,2.81c13.815-0.03,25.881-1.884,39.167-1.853h0.314 l0.333-0.015c4.98-0.306,9.436-0.452,13.436-0.452c12.754,0.007,20.705,1.462,27.159,3.95c6.446,2.488,11.966,6.278,19.43,12.089 l1.922,1.492l2.392,0.421c8.754,1.569,15.239,4.686,20.472,8.919c7.798,6.323,13.049,15.656,16.361,27.232 c3.3,11.53,4.501,25.05,4.49,38.486c0.004,11.316-0.822,22.569-1.776,32.622c-0.953,10.067-2.025,18.848-2.504,25.708h0.004 c-0.088,1.218-0.195,2.266-0.318,3.446l-0.869,8.352l8.119,2.136c1.037,0.275,1.856,0.72,2.377,1.332 c0.486,0.636,1.37,1.738,1.432,5.735c0,2.434-0.436,5.872-1.726,10.396l-0.008,0.024c-4.038,14.255-7.655,22.385-10.729,26.619 c-1.543,2.136-2.867,3.384-4.345,4.425c-1.478,1.026-3.231,1.876-5.68,2.756l-5.359,1.914l-0.992,5.604 c-1.168,6.606-2.572,11.369-4.054,15.105c-2.236,5.589-4.636,9.049-7.729,13.62c-3.062,4.509-6.752,10.121-9.635,18.168 l-0.582,1.608v1.714c0,15.679,0,27.109,0,36.258c-0.011,5.987,2.328,11.354,5.459,15.573c4.75,6.376,11.242,10.986,18.259,15.013 c7.032,3.989,14.684,7.258,21.876,9.952c15.212,5.658,42.64,15.902,65.836,34.444c11.592,9.256,22.06,20.487,29.613,34.137 c7.545,13.673,12.295,29.751,12.31,49.419C459.661,491.329,459.6,491.88,459.592,492.401z"
                      ></path>{" "}
                    </g>{" "}
                  </g>
                </svg>
                About me
              </Link>
            </li>

            <li>
              <Link className="a" to={"/Projects"}>
                <svg
                  viewBox="0 0 1024 1024"
                  class="icon"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#ffffff"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M877.685565 727.913127l-0.584863-0.365539a32.898541 32.898541 0 0 1-8.041866-46.423497 411.816631 411.816631 0 1 0-141.829267 145.777092c14.621574-8.992268 33.62962-5.117551 43.645398 8.772944l0.146216 0.073108a30.412874 30.412874 0 0 1-7.968758 43.206751l-6.141061 4.020933a475.201154 475.201154 0 1 1 163.615412-164.419599 29.974227 29.974227 0 0 1-42.841211 9.357807z m-537.342843-398.584106c7.164571-7.091463 24.71046-9.650239 33.26408 0 10.600641 11.185504 7.164571 29.462472 0 37.138798l-110.612207 107.468569L370.901811 576.14119c7.164571 7.091463 8.114974 27.342343 0 35.384209-9.796455 9.723347-29.828011 8.188081-36.480827 1.535265L208.309909 487.388236a18.423183 18.423183 0 0 1 0-25.953294l132.032813-132.032813z m343.314556 0l132.032813 132.032813a18.423183 18.423183 0 0 1 0 25.953294L689.652124 613.133772c-6.652816 6.579708-25.587754 10.746857-36.553935 0-10.30821-10.235102-7.091463-31.290168 0-38.381632l108.345863-100.669537-111.855041-108.638294c-7.164571-7.676326-9.504023-26.611265 0-36.04218 9.284699-9.138484 26.903696-7.091463 34.068267 0z m-135.54199-26.318833c3.582286-9.504023 21.347498-15.498868 32.679217-11.258612 10.819965 4.020933 17.180349 19.008046 14.256035 28.512069l-119.896906 329.716493c-3.509178 9.504023-20.616419 13.305632-30.193551 9.723347-10.161994-3.509178-21.201282-17.545889-17.545888-26.976804l120.627985-329.716493z"
                      fill="#ffffff"
                    ></path>
                  </g>
                </svg>
                Projects
              </Link>
            </li>

            <li>
              <Link
                className="a"
                target={"blank"}
                to="https://drive.google.com/file/d/1ZN3BOhuOeV-BQBO5pzUNjkEyRw62FXbO/view?usp=sharing"
              >
                <svg
                  fill="#ffffff"
                  viewBox="0 0 1024 1024"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <path d="M532.99 983.04H174.078c-11.309 0-20.48-9.171-20.48-20.48V61.44c0-11.309 9.171-20.48 20.48-20.48h614.4c11.309 0 20.48 9.171 20.48 20.48v326.912c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48V61.44c0-33.931-27.509-61.44-61.44-61.44h-614.4c-33.931 0-61.44 27.509-61.44 61.44v901.12c0 33.931 27.509 61.44 61.44 61.44H532.99c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48z"></path>
                    <path d="M257.535 163.84h448.512c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48H257.535c-11.311 0-20.48 9.169-20.48 20.48s9.169 20.48 20.48 20.48zm0 122.88h448.512c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48H257.535c-11.311 0-20.48 9.169-20.48 20.48s9.169 20.48 20.48 20.48zm0 122.88h448.512c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48H257.535c-11.311 0-20.48 9.169-20.48 20.48s9.169 20.48 20.48 20.48zm0 122.88h253.952c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48H257.535c-11.311 0-20.48 9.169-20.48 20.48s9.169 20.48 20.48 20.48zm0 122.88h253.952c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48H257.535c-11.311 0-20.48 9.169-20.48 20.48s9.169 20.48 20.48 20.48zm315.905-33.28c0-96.139 77.941-174.08 174.08-174.08S921.6 525.941 921.6 622.08c0 96.139-77.941 174.08-174.08 174.08s-174.08-77.941-174.08-174.08zm40.96 0c0 73.517 59.603 133.12 133.12 133.12s133.12-59.603 133.12-133.12-59.603-133.12-133.12-133.12S614.4 548.563 614.4 622.08z"></path>
                    <path d="M857.081 1017.822c20.47 12.355 46.599-2.386 46.599-26.298V694.39c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48v278.991l-99.28-59.938c-9.799-5.941-22.121-5.898-31.916.089l-96.736 59.501V699.511c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48v291.84c0 24.024 26.34 38.743 46.803 26.176l106.974-65.798 109.476 66.094z"></path>
                  </g>
                </svg>
                Resume
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="hamburger-menu">
      
     

      <div className={`navbar__menu ${menuOpen ? "open" : ""}`}>
        <ul className="navbar__list">
          <li className="navbar__item">
            <Link to="/" className="navbar__link" onClick={closeMenu}>
              Home
            </Link>
          </li>
          <li className="navbar__item">
            <Link to="/About" className="navbar__link" onClick={closeMenu}>
              About
            </Link>
          </li>
          <li className="navbar__item">
            <Link to="/Projects" className="navbar__link" onClick={closeMenu}>
              Projects
            </Link>


          </li>
          <li className="navbar__item">
            <Link to="https://drive.google.com/file/d/1ZN3BOhuOeV-BQBO5pzUNjkEyRw62FXbO/view?usp=sharing" className="navbar__link" onClick={closeMenu}>
              Resume
            </Link>


          </li>

        

        </ul>
      </div>

      <button className="navbar__menu-icon" onClick={toggleMenu}>
        <span className="navbar__menu-icon__line"></span>
        <span className="navbar__menu-icon__line"></span>
        <span className="navbar__menu-icon__line"></span>
      </button>
   
      </div>
    </>
  );
}

export default Navbar;
